import { useTranslation } from 'react-i18next'
import styles from './OrderTestaments.module.css'
import { Link, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { axiosConfig } from 'utils/axiosConfig'
import { Container } from 'react-bootstrap'
import AllOrderTestamentsTable from 'components/Tables/AlOrderTestamentsTable/AllOrderTestamentsTable'
import { useSelector } from 'react-redux'
function OrderTestaments() {
  const {t} =useTranslation()
  const params = useParams()
  const user =useSelector((state:any)=>state?.GlobalReducer?.user)

  const [item,setItem]=useState({} as any)
  const [isLoading,setIsLoading]=useState(false)
  const [isDeleting,setIsDeleting] =useState<[Boolean]>([false])
  function getOrderTestments(){
    setIsLoading(true)
    axiosConfig.get(`/orders/single-order/${params?.id}`,{
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`,
        
      }
    }).then(res=>{
      setIsLoading(false)
      setItem(res.data?.data)
      // let deletedNumber:any = [...Array(res.data.data.length)]
      // setIsDeleting(deletedNumber)
    }).catch(err=>{
      setIsLoading(false)
      console.log(err)
    })
  }
  function deleteItem(orderId:String ,index:any,testmentId:String){
    let modifiedDelete:[Boolean]=[...isDeleting]
      modifiedDelete[index]=true
    setIsDeleting(modifiedDelete)
      axiosConfig.delete(`/orders/delete-testment-from-order/${orderId}?testment_id=${testmentId}`,{
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        }
      }).then(res=>{
        let modifiedDelete:[Boolean]=[...isDeleting]
        modifiedDelete[index]=false
        setIsDeleting(modifiedDelete)
        toast.success(t('Item Deleted Successfully'))
        getOrderTestments()
      }).catch(err=>{
        let modifiedDelete:[Boolean]=[...isDeleting]
        modifiedDelete[index]=false
        setIsDeleting(modifiedDelete)
        toast.error(err?.response?.data?.message)
        console.log(err)
      })
  }
  function receiveTestment(orderId:String ,index:any,testmentId:String,receivedStatus:String){
    let modifiedDelete:[Boolean]=[...isDeleting]
      modifiedDelete[index]=true
    setIsDeleting(modifiedDelete)
      axiosConfig.post(`/orders/received-testment-from-order/${orderId}`,{testment_id:testmentId,received_status:receivedStatus},{
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        }
      }).then(res=>{
        let modifiedDelete:[Boolean]=[...isDeleting]
        modifiedDelete[index]=false
        setIsDeleting(modifiedDelete)
        toast.success(t('Item Changed Successfully'))
        getOrderTestments()
      }).catch(err=>{
        let modifiedDelete:[Boolean]=[...isDeleting]
        modifiedDelete[index]=false
        setIsDeleting(modifiedDelete)
        toast.error(err?.response?.data?.message)
        console.log(err)
      })
  }
  useEffect(()=>{
    getOrderTestments()
  },[])
  return (
    <>
      <section className={styles['page-wrapper']}>
        <Container>
          <div className={styles['page-header']}>
            <h1 className={styles['page-header__title']}>
            {t('Order')} #{item?.item_number} {t('Testaments')}
            </h1>
            {/* <Link to='/dashboard/add-technician' className={styles['page-header__link']}>
              {t('Export PDF')}
            </Link> */}
            {
              user?.permission_type=='admin' &&
              <Link to={`/orders/add-order-testments/${params?.id}`} className={styles['page-header__link']}>
                {t('Add Testaments')}
              </Link>
            }
          </div>
        </Container>
        <AllOrderTestamentsTable 
          order={item}
          items={item?.testments} 
          deleteItem={deleteItem} 
          receiveTestment={receiveTestment} 
          isDeleting={isDeleting} 
        />
      </section>
    </>
  )
}

export default OrderTestaments